import { z } from 'zod';

/** Contract for GET admin/users/:userId/rewards. `claimedRewards` isn't shown, so it isn't kept. */

const text = z.string().nullish();

const couponSchema = z.object({
  brandName: text,
  logoUrl: text,
  offerText: text,
  offerSubtitle: text,
});

const rewardSchema = couponSchema.extend({
  id: z.union([z.number(), z.string()]),
  level: z.number().int(),
  status: z.string(),
  couponCode: text,
  scansAtUnlock: z.number().nullish(),
  unlockedAt: text,
  claimedAt: text,
  expiresAt: text,
});

export const rewardsSchema = z.object({
  scans: z.object({
    approved: z.number().int().nonnegative(),
    pending: z.number().int().nonnegative(),
    rejected: z.number().int().nonnegative(),
  }),
  activeTarget: z
    .object({
      level: z.number().int(),
      tierName: text,
      scansRequired: z.number().int(),
      scansDone: z.number().int(),
      scansRemaining: z.number().int(),
      progressPercent: z.number(),
      tierProgressPercent: z.number(),
      coupon: couponSchema.nullable(),
    })
    .nullable(),
  targets: z.array(
    z.object({
      level: z.number().int(),
      tierName: text,
      scansRequired: z.number().int().positive(),
      previousScansRequired: z.number().int().nonnegative(),
      state: z.string(),
      coupon: couponSchema.nullable(),
      reward: rewardSchema.nullable(),
    }),
  ),
  allTiersCompleted: z.boolean(),
  hasActivePackage: z.boolean(),
});
